import { render, staticRenderFns } from "./TpcDialog.vue?vue&type=template&id=9690d366&scoped=true"
import script from "./TpcDialog.vue?vue&type=script&lang=js"
export * from "./TpcDialog.vue?vue&type=script&lang=js"
import style0 from "./TpcDialog.vue?vue&type=style&index=0&id=9690d366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9690d366",
  null
  
)

export default component.exports